import PubSub from 'pubsub-js';

export const ACTIVITY_SESSION_END_EVENT_ID = Symbol('activity.sessionEnd');

export const activitySessionEndEventPubSub:
PubSubJS.Base<undefined, typeof ACTIVITY_SESSION_END_EVENT_ID> = PubSub;
